import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=00788536&scoped=true&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=00788536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00788536",
  null
  
)

export default component.exports